import { CartController } from './_controller'

export function initCartPage() {
  if (document.querySelector('[data-cart-body]')) {
    new CartController()
  }
}
